import type { OrderFlowLoadFailureReason } from 'utils/analytics/orderFlowLoad'
import type { OrderFlowFirstScreen } from './useOrderFlowLoaded'

interface ResolveOrderFlowFirstScreenArgs {
  isEmbed: boolean
  isFirstScreenSettled: boolean
  showNoOrderPermission: boolean
  showValueProposition: boolean
  hasPropertyRef: boolean
  isPropertySuccess: boolean
  isPropertyError: boolean
}

interface ResolvedOrderFlowFirstScreen {
  ready: boolean
  firstScreen: OrderFlowFirstScreen
  failureReason: OrderFlowLoadFailureReason | null
}

/** In the embed the product step renders nothing until the property settles, so a load is only reported then. */
export const resolveOrderFlowFirstScreen = ({
  isEmbed,
  isFirstScreenSettled,
  showNoOrderPermission,
  showValueProposition,
  hasPropertyRef,
  isPropertySuccess,
  isPropertyError,
}: ResolveOrderFlowFirstScreenArgs): ResolvedOrderFlowFirstScreen => {
  if (showNoOrderPermission) return { ready: isFirstScreenSettled, firstScreen: 'no_permission', failureReason: null }
  if (!isEmbed) return { ready: isFirstScreenSettled, firstScreen: 'steps', failureReason: null }
  if (showValueProposition) return { ready: isFirstScreenSettled, firstScreen: 'overlay', failureReason: null }
  if (hasPropertyRef && isPropertyError) return { ready: isFirstScreenSettled, firstScreen: 'error', failureReason: 'PROPERTY_FETCH_FAILED' }
  return { ready: isFirstScreenSettled && (!hasPropertyRef || isPropertySuccess), firstScreen: 'steps', failureReason: null }
}
